import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  Output,
  EventEmitter,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { DocumentoService } from "@app/shared/services/documento.service";
import { LoaderService } from "@app/shared/services/loader.service";
import { AutenticazioneService } from "@app/shared/services/autenticazione.service";
import { DocumentoVO } from "@app/shared/vo/documentoVO";
import { PaginazioneVO } from "@app/shared/vo/paginazioneVO";
import { OrdinamentoVO } from "@app/shared/vo/ordinamentoVO";
import { TipoElementoEnum } from "@app/shared/enum/tipo-elemento-enum";
import { TipoSupportoDocumentoEnum } from "@app/shared/enum/tipo-supporto-documento-enum";
import { FormFileCaricatoVO } from "@app/shared/vo/form-file-caricatoVO";
import { FiltroRicercaUnitaDocumentariaVO } from "@app/shared/vo/filtro-ricerca-unita-documentariaVO";
import { UnitaDocumentariaVO } from "@app/shared/vo/unita-documentariaVO";

@Component({
  selector: "app-modale-ricerca-documento",
  templateUrl: "./modale-ricerca-documento.component.html",
})
//@TODO fare ricerca avanzata
export class ModaleRicercaDocumentoComponent implements OnInit {
  @ViewChild("templateModaleRicercaDocumento", { static: false })
  public ricercaDocumentoModal: TemplateRef<any>;

  @Output() emettiDocumento: EventEmitter<
    FormFileCaricatoVO
  > = new EventEmitter<FormFileCaricatoVO>();
  public modalRef: BsModalRef;
  reorderable: boolean = true;
  loadingIndicator: boolean = false;
  rows: UnitaDocumentariaVO[];
  visualizzaDetail = false;
  filtro: FiltroRicercaUnitaDocumentariaVO; // TODO modificare in VO con mapper
  paginazione: PaginazioneVO;
  ordinamento: OrdinamentoVO;
  elemento: TipoElementoEnum;
  messages = {
    emptyMessage: "Nessun documento trovato",
    totalMessage: "totali",
  };
  private config = {
    class: "modal-dialog modal-info modal-xlg",
    animated: true,
  };
  constructor(
    private modalService: BsModalService,
    private documentoService: DocumentoService,
    private loaderService: LoaderService,
    private autenticazioneService: AutenticazioneService
  ) {
    this.ordinamento = new OrdinamentoVO();
    this.paginazione = new PaginazioneVO();
    this.ordinamento.elemento = "nome";
    this.ordinamento.direzione = 0;
    this.paginazione.size = 10; // TODO cambiare valore ,
    this.paginazione.pageNumber = 0;
    this.elemento = null;
    this.filtro = new FiltroRicercaUnitaDocumentariaVO();
    this.filtro.ricercaSemplice = "";
    this.filtro.limitazioniVisibilitaUtente = true;
    this.filtro.tipo = TipoSupportoDocumentoEnum.DIGITALE;
  }

  ngOnInit() { }

  openModal() {
    this.modalRef = this.modalService.show(
      this.ricercaDocumentoModal,
      this.config
    );
  }

  public findFascicoliPerPage(pageInfo: any) {
    this.paginazione.pageNumber = pageInfo;
  }

  public sortFascicoli(event: any) {
    this.ordinamento = new OrdinamentoVO();
    console.log("sortInfo received: >> ", event);
    const sort = event.sorts[0];
    // const dir = sort.dir;
    // const prop = sort.prop;
    console.log(sort.prop);
    this.ordinamento.elemento = sort.prop;
    console.log(this.ordinamento.elemento);
    if (event.newValue == "asc") {
      this.ordinamento.direzione = 0;
    } else {
      this.ordinamento.direzione = 1;
    }
    this.paginazione.pageNumber = 0;

    this.documentoService
      .ricercaUnitaDocumentarie(this.filtro, this.paginazione, this.ordinamento)
      .subscribe(
        (pagedData) => {
          this.paginazione = pagedData.paginazione;
          this.rows = pagedData.resultList;
          this.rows = JSON.parse(JSON.stringify(this.rows));
          this.loadingIndicator = false;
          console.log(
            "ricercaDocumenti Component rows size: ",
            this.rows.length
          );
        },
        (err) => {
          console.log("ListFascicoli Component getLista err", err);
          this.loadingIndicator = false;
        }
      );
  }
  public setFascicoli(pageInfo) {
    console.log("setPage -- START", this.filtro);
    this.loadingIndicator = true;
    this.paginazione.pageNumber = pageInfo;

    //  this.filtro.cfOperatore = this.utente.id;
    this.documentoService
      .ricercaUnitaDocumentarie(this.filtro, this.paginazione, this.ordinamento)
      .subscribe(
        (pagedData) => {
          this.paginazione = pagedData.paginazione;
          this.rows = pagedData.resultList;
          this.rows = JSON.parse(JSON.stringify(this.rows));
          this.loadingIndicator = false;
        },
        (err) => {
          console.log("ListFascicoli Component getLista err", err);
          this.loadingIndicator = false;
        }
      );
  }
  ricevoDocumento(item: DocumentoVO) {
    const fileCaricato: FormFileCaricatoVO = new FormFileCaricatoVO();
    fileCaricato.nome = item.nome;
    fileCaricato.idRepository = item.idRepository;
    fileCaricato.hash = item.hash;
    fileCaricato.dimensioni = item.dimensioni;
    this.emettiDocumento.emit(fileCaricato);
    this.modalRef.hide();
  }
  cercaUd() {
    this.paginazione.pageNumber = 0;
    console.log("cercaFascicolo " + this.filtro, this.paginazione.pageNumber);
    sessionStorage.setItem("filtro", JSON.stringify(this.filtro));
    if (this.filtro.ricercaSemplice.length > 2) {
      this.loadingIndicator = true;

      this.documentoService
        .ricercaUnitaDocumentarie(
          this.filtro,
          this.paginazione,
          this.ordinamento
        )
        .subscribe(
          (response) => {
            console.log(response);
            this.paginazione = response.paginazione;
            this.rows = response.resultList;
            this.loadingIndicator = false;
            console.log("ricercaDocumenti Component rows", this.rows);
          },
          (err) => {
            console.log("errore", err);
            this.loadingIndicator = false;
          }
        );
    }
  }
}
